module.exports = __webpack_public_path__ + "img/zy1.c06e154b.png";